import classnames from 'classnames';
import React from 'react';
import styles from './rotating-spinner.module.scss';

export type ColorOption = 'blue' | 'black' | 'white';

interface Props {
    color?: ColorOption;
    variant?: 'default' | 'thinLarge';
}

const RotatingSpinner: React.FC<Props> = ({
    color,
    variant = 'default',
}: Props) => (
    <div
        className={classnames(
            styles.spinner,
            color === 'black' && styles.blackSpinner,
            color === 'white' && styles.whiteSpinner,
            variant === 'thinLarge' && styles.thinLarge
        )}
    />
);

export default RotatingSpinner;
